/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-indicator',
  templateUrl: './active-indicator.component.html',
  styleUrls: ['./active-indicator.component.scss'],
})
export class ActiveIndicatorComponent implements OnInit {
  @Input() active: boolean;

  constructor() {}

  ngOnInit() {}
}
